module.exports = __webpack_public_path__ + "img/top.b4f78d40.png";